import React from "react";

import { cn } from "@/lib/utils";

import { CommandEmpty as CommandEmptyPrimitive, useCommandState } from "cmdk";

import { BodyText } from "@/components/ui/Text";

interface CommandEmptyProps {
  noResultsText: string;
  enteredLength?: number;
  minLength?: number;
}

const CommandEmpty = React.forwardRef<
  React.ElementRef<typeof CommandEmptyPrimitive>,
  React.ComponentPropsWithoutRef<typeof CommandEmptyPrimitive> &
    CommandEmptyProps
>(({ noResultsText, enteredLength, minLength, ...props }, ref) => {
  const render = useCommandState((state) => state.filtered.count === 0);

  if (!render) return null;

  const text =
    enteredLength && minLength && enteredLength < minLength
      ? `Enter at least ${minLength} character${minLength !== 1 && "s"} to search.`
      : noResultsText;
  return (
    <CommandEmptyPrimitive
      ref={ref}
      className={cn(
        "max-h-[200px] overflow-y-auto overflow-x-hidden border border-secondary rounded-md absolute bg-white w-full px-2 py-1.5 box-border z-50",
      )}
      {...props}
    >
      <BodyText size="sm">{text}</BodyText>
    </CommandEmptyPrimitive>
  );
});

CommandEmpty.displayName = CommandEmptyPrimitive.displayName;
export { CommandEmpty };
